// angular
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// material 
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'

// models 
import { MailingRecord } from '../../shared/models/MailingRecord';

// services 
import { MailingRecordService } from '../../shared/services/mailingRecord.service'; 
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { MailingRecordEditFormComponent } from '../../shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component';

declare var $: any;
 
@Component({
  selector: 'app-mailing-record-list',
  templateUrl: './mailing-record-list.component.html'
})

export class MailingRecordListComponent implements OnInit {
  
  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<MailingRecord>();
  displayedColumns: string[] = ['patientId', 'fullName', 'dateOfBirth', 'gender', 'lastExamDate', 'months', 'actions'];
  public mailingFileId = 0;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private mailingRecordService: MailingRecordService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService
  ) { }

  ngOnInit() { 
  }
 
  // gets mailing records based on mailing file id
  getRecords(id: number): void {
    this.mailingFileId = id;
    if (id > 0) { 
      this.mailingRecordService.getAll(id).subscribe(result => {
          if (result.length) {
            this.dataSource.data = result;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.openModal();
            $('.overlay').addClass('active');
            $('#myMailingModal').addClass('active');  
          }

      }, error => console.error(error));
    }
  }

  openModal(): void { 
    $('.overlay').addClass('active');
    $('#myMailingModal').addClass('active');
  }

  closeModal(): void {
    $('#myMailingModal').removeClass('active');
    $('.overlay').removeClass('active');
  }

  // delete location
  deleteMailingRecord(id: number) {

    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {
        if (confirmed) {
          this.mailingRecordService.delete(id).subscribe(() => {
            this.showNotification('The mailing record has been deleted successfully!', 'Okay!');
            this.getRecords(this.mailingFileId);
          });
        }
      }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      );
  }

  // edit location
  editMailingRecord(model: MailingRecord) { 
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(MailingRecordEditFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Edit Record';
    modalRef.componentInstance.mailingRecord = model;
   
    // modal result
    modalRef.result.then((result) => {
      if (result) {
        this.getRecords(this.mailingFileId);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    );
  }

  // filter locations
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }
}
